// Shared helpers for the admin analytics panels.
export const formatMoney = (value) => `${Number(value || 0).toFixed(2)}€`;

export const formatNumber = (value) => {
  const n = Number(value || 0);
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}k`;
  return `${n}`;
};

/**
 * Returns a delta object: { sign: '+' | '-' | '=', pct: number, absDelta: number }
 * Special-cases the "from zero" jump — a real 10% jump is meaningful, but
 * going from 0 → 5 shows the absolute count instead of "Infinity%".
 */
export const computeDelta = (current, previous) => {
  const cur = Number(current || 0);
  const prev = Number(previous || 0);
  const absDelta = cur - prev;
  if (prev === 0 && cur === 0) return { sign: '=', pct: 0, absDelta: 0, label: '—' };
  if (prev === 0 && cur > 0) return { sign: '+', pct: null, absDelta, label: `+${cur}` };
  if (prev > 0 && cur === 0) return { sign: '-', pct: -100, absDelta, label: `-100%` };
  const pct = (absDelta / prev) * 100;
  const sign = pct > 0 ? '+' : pct < 0 ? '-' : '=';
  return { sign, pct, absDelta, label: `${pct >= 0 ? '+' : ''}${pct.toFixed(0)}%` };
};

export const deltaColor = (delta) => {
  if (!delta) return '#666';
  if (delta.sign === '+') return '#00B341';
  if (delta.sign === '-') return '#DD0608';
  return '#999';
};

export const formatShortDate = (yyyyMmDd) => {
  if (!yyyyMmDd) return '';
  const [, m, d] = yyyyMmDd.split('-');
  return `${d}/${m}`;
};
